








import { Vue, Component } from 'vue-property-decorator'
@Component
export default class DialogFooter extends Vue {
  /**
   * 方法
   * 取消
   * on-handle-close
   * onHandleClose
   * 确认
   * on-handle-confirm
   * onHandleConfirm
   */
}
